import { type NodeProps, type Node } from "@xyflow/react";
import styles from "./WorkflowNode.module.css";
import type { PipelineObjectType } from "../../hooks/usePipelines";

interface PipelineGroupData {
  objectType: PipelineObjectType;
  pipelineId: string;
  name: string;
  onRemove?: (objectType: PipelineObjectType, pipelineId: string) => void;
}

const TYPE_LABEL: Record<PipelineObjectType, string> = {
  deals: "Deals",
  tickets: "Tickets",
};

export default function PipelineGroupNode({ data }: NodeProps<Node>) {
  const d = data as unknown as PipelineGroupData;
  return (
    <div className={styles.group}>
      <div className={styles.groupHeader}>
        <span className={styles.groupTitle}>
          {d.name}
          <span
            style={{
              marginLeft: 8,
              fontSize: 11,
              fontWeight: 500,
              color: "var(--kh-text-muted, #888)",
              textTransform: "uppercase",
              letterSpacing: "0.05em",
            }}
          >
            {TYPE_LABEL[d.objectType]}
          </span>
        </span>
        {d.onRemove && (
          <button
            type="button"
            className={styles.groupRemove}
            onClick={(e) => {
              e.stopPropagation();
              d.onRemove?.(d.objectType, d.pipelineId);
            }}
            aria-label="Remove from canvas"
          >
            ×
          </button>
        )}
      </div>
    </div>
  );
}
